export enum EOrdenacao {
  Asc = 1,
  Desc = 2,
}
